// extracted by mini-css-extract-plugin
export var desc = "trialStepCreatingAccount-module--desc--5027b";
export var descInner = "trialStepCreatingAccount-module--descInner--bf74d";
export var rotateForever = "trialStepCreatingAccount-module--rotate-forever--3f2e7";
export var spinner = "trialStepCreatingAccount-module--spinner--9c1c5";
export var statusUpdate = "trialStepCreatingAccount-module--statusUpdate--33c19";
export var subtext = "trialStepCreatingAccount-module--subtext--225b1";
export var textlink = "trialStepCreatingAccount-module--textlink--1e30b";